export const LOG_SPENT_TIME_ON_PAGE = 'LOG_SPENT_TIME_ON_PAGE';